import { useEffect } from 'react';
import { useAxios } from 'src/hooks/use-axios';
import { SurrenderRootResponse } from 'src/pages/reporting/surrender/types';

export function useSurrenderRoot() {
  const surrenderRoot = useAxios(
    (axios, signal) =>
      axios.request<SurrenderRootResponse>({
        signal,
        url: PRISMA_CONFIG.surrenderService,
      }),
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    surrenderRoot.execute();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return surrenderRoot;
}

export type SurrenderRootRequest = ReturnType<typeof useSurrenderRoot>;
